import { createSlice } from "@reduxjs/toolkit";

const moduleAccessData = createSlice({
  name: "moduleAccessData", // Change the name of the slice here
  initialState: [],
  reducers: {
    setModuleAccessData: (state, action) => {
      return action.payload;
    },
  },
});

export const { setModuleAccessData } = moduleAccessData.actions;

export default moduleAccessData.reducer;
